export default async function getParentSuperorderChecklistActivities(repository, superOrderId) {
  const response = await repository.getParentSuperorderChecklistActivities(superOrderId);

  return response.reduce(
    (activities, activity) => activities.concat(activity.activityClient),
    [],
  );
}
